import axios from 'axios';
import MainService from './MainService';

export default class ExpenseService extends MainService {
  constructor() {
		super();
		this.url = `${this.apiUrl}/expenses`;
  }

  remove(id) {
    return axios.delete(this.url + "/" + id);
  }

  save(expense) {
    return axios.post(this.url, expense);
  }
}



// WEBPACK FOOTER //
// ./src/service/ExpenseService.js